module.exports = __webpack_public_path__ + "media/images/icons/outlined/compress-c459a2313cb1498bf61dae429dd14b23.svg";